import classNames from 'classnames/bind';
import React from 'react';
import { findFirst } from "../../../../../../../../utils/arrays";
import { withOnMountHandler } from "../../../../../../../../utils/withOnMountHandler";
import { Text } from "../../../../../../../../components/Text";
import styles from "./styles.pcss";
import { getMaxHeight } from "./utils";
var cn = classNames.bind(styles);
export var PaymentLayout = withOnMountHandler(function (_ref) {
  var children = _ref.children,
    title = _ref.title,
    isLoading = _ref.isLoading,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "PaymentMethodSection-PaymentLayout"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('text'),
    color: "secondary",
    isLoading: isLoading,
    variant: "display-extrasmall"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cn('content'),
    style: findFirst([!!size && {
      maxHeight: "".concat(getMaxHeight(size), "px"),
      overflowY: 'auto'
    }])
  }, children));
});